<template>
    <h1>merchant add</h1>
</template>

<script>
export default {
    
}
</script>